import { doGet } from "../api/baseAPI";
import { GROLOG_URL } from "../constant/apiConstant";

export const dropdownCountry = async (token, params) => {
  const url = `${GROLOG_URL}/country`;
  const result = { ok: false, list: undefined, message: undefined, code: null }

  try {
    const res = await doGet(token, url, params);

    if (res?.status === 200) {
      result.code = 200; 
      result.ok = true;
      result.list = res?.data?.payload?.data;
      result.message = res?.data?.payload?.status?.message;
    }

  } catch (error) {
    const errorCode =  error?.response?.status;
    const errorMessage =  error?.response?.data?.payload?.message;

    result.code = errorCode;
    result.ok = false;
    result.message = errorMessage;
    delete result.list;
  }

  return result;
}

export const dropdownIsland = async (token, params) => {
  const url = `${GROLOG_URL}/island`;
  const result = { ok: false, list: undefined, message: undefined, code: null }

  try {
    const res = await doGet(token, url, params);

    if (res?.status === 200) {
      result.code = 200; 
      result.ok = true;
      result.list = res?.data?.payload?.data;
      result.message = res?.data?.payload?.status?.message;
    }

  } catch (error) {
    const errorCode =  error?.response?.status;
    const errorMessage =  error?.response?.data?.payload?.message;

    result.code = errorCode;
    result.ok = false;
    result.message = errorMessage;
    delete result.list;
  }

  return result;
}

export const dropdownProvince = async (token, params) => {
  const url = `${GROLOG_URL}/province`;
  const result = { ok: false, list: undefined, message: undefined, code: null }

  try {
    const res = await doGet(token, url, params);

    if (res?.status === 200) {
      result.code = 200; 
      result.ok = true;
      result.list = res?.data?.payload?.data;
      result.message = res?.data?.payload?.status?.message;
    }

  } catch (error) {
    const errorCode =  error?.response?.status;
    const errorMessage =  error?.response?.data?.payload?.message;

    result.code = errorCode;
    result.ok = false;
    result.message = errorMessage;
    delete result.list;
  }

  return result;
}

export const dropdownDistrict = async (token, params) => {
  const url = `${GROLOG_URL}/district`;
  const result = { ok: false, list: undefined, message: undefined, code: null }

  try {
    const res = await doGet(token, url, params);

    if (res?.status === 200) {
      result.code = 200; 
      result.ok = true;
      result.list = res?.data?.payload?.data;
      result.message = res?.data?.payload?.status?.message;
    }

  } catch (error) {
    const errorCode =  error?.response?.status;
    const errorMessage =  error?.response?.data?.payload?.message;

    result.code = errorCode;
    result.ok = false;
    result.message = errorMessage;
    delete result.list;
  }

  return result;
}

export const dropdownSubDistrict = async (token, params) => {
  const url = `${GROLOG_URL}/sub_district`;
  const result = { ok: false, list: undefined, message: undefined, code: null }

  try {
    const res = await doGet(token, url, params);

    if (res?.status === 200) {
      result.code = 200; 
      result.ok = true;
      result.list = res?.data?.payload?.data;
      result.message = res?.data?.payload?.status?.message;
    }

  } catch (error) {
    const errorCode =  error?.response?.status;
    const errorMessage =  error?.response?.data?.payload?.message;

    result.code = errorCode;
    result.ok = false;
    result.message = errorMessage;
    delete result.list;
  }

  return result;
}

export const dropdownUrbanVillage = async (token, params) => {
  const url = `${GROLOG_URL}/urban_village`;
  const result = { ok: false, list: undefined, message: undefined, code: null }

  try {
    const res = await doGet(token, url, params);

    if (res?.status === 200) {
      result.code = 200; 
      result.ok = true;
      result.list = res?.data?.payload?.data;
      result.message = res?.data?.payload?.status?.message;
    }

  } catch (error) {
    const errorCode =  error?.response?.status;
    const errorMessage =  error?.response?.data?.payload?.message;

    result.code = errorCode;
    result.ok = false;
    result.message = errorMessage;
    delete result.list;
  }

  return result;
}

export const dropdownPostalCode = async (token, params) => {
  const url = `${GROLOG_URL}/postal_code`;
  const result = { ok: false, list: undefined, message: undefined, code: null }

  try {
    const res = await doGet(token, url, params);

    if (res?.status === 200) {
      result.code = 200; 
      result.ok = true;
      result.list = res?.data?.payload?.data;
      result.message = res?.data?.payload?.status?.message;
    }

  } catch (error) {
    const errorCode =  error?.response?.status;
    const errorMessage =  error?.response?.data?.payload?.message;

    result.code = errorCode;
    result.ok = false;
    result.message = errorMessage;
    delete result.list;
  }

  return result;
}

export const dropdownPersonTitle = async (token, params) => {
  const url = `${GROLOG_URL}/person_title`;
  const result = { ok: false, list: undefined, message: undefined, code: null }

  try {
    const res = await doGet(token, url, params);

    if (res?.status === 200) {
      result.code = 200; 
      result.ok = true;
      result.list = res?.data?.payload?.data;
      result.message = res?.data?.payload?.status?.message;
    }

  } catch (error) {
    const errorCode =  error?.response?.status;
    const errorMessage =  error?.response?.data?.payload?.message;

    result.code = errorCode;
    result.ok = false;
    result.message = errorMessage;
    delete result.list;
  }

  return result;
}